/// <amd-module name="RMWidgets/DeploymentStatusWidget/components/CellToolTip" />
import * as React from "react";

import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";

import { DSWTooltip } from "RMWidgets/DeploymentStatusWidget/DSWContracts";
import * as Resources from "RMWidgets/DeploymentStatusWidget/Resources";

export interface CellToolTipProps {
    toolTip: DSWTooltip;
}

export class CellToolTip extends VssComponent<CellToolTipProps> {
    constructor(props: CellToolTipProps, context: IVssComponentContext) {
        super(props, context);
    }

    render(): JSX.Element {
        if (!this.props.toolTip) {
            return <></>;
        }

        return <div className={"dsw-tooltip-container"}>
            <div className={"build-deployment-stats-container"}>
                <div className={"stats-container-left-pane"}>
                    <Icon iconName={"Build"} />
                    <div className={"stats"}>
                        <div className={"tooltip-header"}>{Resources.DSWTooltipBuild}</div>
                        <div className={"tooltip-value"}>{this.props.toolTip.build}</div>
                        <div className={"tooltip-value"}>{!this.props.toolTip.build && Resources.DSWTooltipNotApplicable}</div>
                    </div>
                    <div className={"stats"}>
                        <div className={"tooltip-header"}>{Resources.DSWTooltipBuildStatus}</div>
                        <div className={"tooltip-value"}>{this.props.toolTip.buildStatus}</div>
                        <div className={"tooltip-value"}>{!this.props.toolTip.buildStatus && Resources.DSWTooltipNotApplicable}</div>
                    </div>
                </div>

                <div className={"stats-container-right-pane"}>
                    <div className={"stats-container-left-pane"}>
                        <Icon iconName={"Rocket"} />
                        <div className={"stats"}>
                            <div className={"tooltip-header"}>{Resources.DSWTooltipRelease}</div>
                            <div className={"tooltip-value"}>{this.props.toolTip.release}</div>
                            <div className={"tooltip-value"}>{!this.props.toolTip.release && Resources.DSWTooltipNotApplicable}</div>
                        </div>
                        <div className={"stats"}>
                            <div className={"tooltip-header"}>{Resources.DSWTooltipDeploymentStatus}</div>
                            <div className={"tooltip-value"}>{this.props.toolTip.deploymentStatus}</div>
                            <div className={"tooltip-value"}>{!this.props.toolTip.deploymentStatus && Resources.DSWTooltipNotApplicable}</div>
                        </div>
                        <div className={"stats"}>
                            <div className={"tooltip-header"}>{Resources.DSWTooltipEnvironment}</div>
                            <div className={"tooltip-value"}>{this.props.toolTip.environment}</div>
                            <div className={"tooltip-value"}>{!this.props.toolTip.environment && Resources.DSWTooltipNotApplicable}</div>
                        </div>
                        <div className={"stats"}>
                            <div className={"tooltip-header"}>{Resources.DSWTooltipDeploymentDuration}</div>
                            <div className={"tooltip-value"}>{this.props.toolTip.deploymentDuration}</div>
                            <div className={"tooltip-value"}>{!this.props.toolTip.deploymentDuration && Resources.DSWTooltipNotApplicable}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="test-stats-container">
                <div style={{ display: "inline-block" }}>
                    <Icon iconName={"TestBeaker"} className={"test-icon"} />
                    <div className={"stats-container-left-pane"}>
                        <div>
                            <div className={"tooltip-header"}>{Resources.DSWTooltipTestsPassed}</div>
                            <div className={"tooltip-value"}>{this.props.toolTip.testsPassed}</div>
                            <div className={"tooltip-value"}>{!this.props.toolTip.testsPassed && Resources.DSWTooltipNotApplicable}</div>
                        </div>
                    </div>
                    <div className={"stats-container-left-pane"}>
                        <div className={"stats"}>
                            <div className={"tooltip-header"}>{Resources.DSWTooltipTestRunDuration}</div>
                            <div className={"tooltip-value"}>{this.props.toolTip.testRunDuration}</div>
                            <div className={"tooltip-value"}>{!this.props.toolTip.testRunDuration && Resources.DSWTooltipNotApplicable}</div>
                        </div>
                    </div>
                    {this.props.toolTip.abortedRuns &&
                        <div className={"stats-container-left-pane"}>
                            <div className={"stats"}>
                                <div className={"tooltip-header"}>{Resources.DSWTooltipAbortedRuns}</div>
                                <div className={"tooltip-value"}>{this.props.toolTip.abortedRuns}</div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>;
    }
}

VssComponent.register("multiLineToolTip", CellToolTip);